export default __webpack_public_path__ + "static/media/sidebar-purple.8727cef1.png";